<h1 class="strong" mat-dialog-title>
  {{ 'header.userSettings.impersonation.assignEmployee' | translate }}
</h1>
<div [formGroup]="assignImpersonatorForm" mat-dialog-content>
  <div class="card-groups-container" mat-dialog-content>
    <div class="card-container">
      <div class="width-100">
        <app-people-picker
          [multipleSelectionAllowed]="false"
          [label]="'navigation.employees'"
          [disabled]="false"
          [isExternalUser]="false"
          [items]="[]"
          (selection)="setSelectedEmployee($event)"
        ></app-people-picker>
      </div>
      <div class="assign-impersonator-dialog__dates">
        <mat-form-field
          [class.mat-form-field-invalid]="assignImpersonatorForm.hasError('validChronology') || assignImpersonatorForm.hasError('maxOneYear')"
          appearance="outline"
          floatLabel="always"
        >
          <mat-label>{{ 'default.from' | translate }}</mat-label>
          <input [matDatepicker]="validFromPicker" matInput formControlName="validFrom" />
          <mat-datepicker-toggle [for]="validFromPicker" matIconSuffix></mat-datepicker-toggle>
          <mat-datepicker #validFromPicker [calendarHeaderComponent]="DatepickerHeaderComponent"></mat-datepicker>
        </mat-form-field>
        <mat-form-field
          [class.mat-form-field-invalid]="assignImpersonatorForm.hasError('validChronology') || assignImpersonatorForm.hasError('maxOneYear')"
          appearance="outline"
          floatLabel="always"
        >
          <mat-label>{{ 'default.until' | translate }}</mat-label>
          <input
            [matDatepicker]="validToPicker"
            [min]="$safeNavigationMigration(assignImpersonatorForm.get('validFrom')?.value)"
            [max]="maxValidToDate"
            matInput
            formControlName="validTo"
          />
          <mat-datepicker-toggle [for]="validToPicker" matIconSuffix></mat-datepicker-toggle>
          <mat-datepicker #validToPicker [calendarHeaderComponent]="DatepickerHeaderComponent"></mat-datepicker>
        </mat-form-field>
      </div>
      @if (assignImpersonatorForm.hasError('maxOneYear')) {
        <mat-error style="margin-top: -45px; font-size: 12px">
          {{ 'notifications.impersonation.impersonationDuration' | translate }}
        </mat-error>
      }
    </div>
  </div>
  <div mat-dialog-actions>
    <button class="btn btn-secondary" (click)="closeWindow()">
      {{ 'default.cancel' | translate }}
    </button>
    <button
      class="btn btn-primary"
      [disabled]="assignImpersonatorForm.hasError('validChronology') || assignImpersonatorForm.hasError('maxOneYear') || !selectedEmployee"
      (click)="save()"
    >
      {{ 'default.save' | translate }}
    </button>
  </div>
</div>
